import { V as Vue } from "./custom-attrs-da459aec.js";
import { n as normalizeComponent, B as BootstrapPlugin } from "./bootstrap-plugin-f9c19818.js";
import { C as CommonPlugin } from "./common-plugin-a3287961.js";
import { A as AdminLtePlugin } from "./admin-lte-plugin-827e0af3.js";
import { g as getDefaultExportFromCjs } from "./_commonjsHelpers-ca272635.js";
import "./numeral-format-fad6744b.js";
var parseMs = (milliseconds) => {
  if (typeof milliseconds !== "number") {
    throw new TypeError("Expected a number");
  }
  const roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil;
  return {
    days: roundTowardsZero(milliseconds / 864e5),
    hours: roundTowardsZero(milliseconds / 36e5) % 24,
    minutes: roundTowardsZero(milliseconds / 6e4) % 60,
    seconds: roundTowardsZero(milliseconds / 1e3) % 60,
    milliseconds: roundTowardsZero(milliseconds) % 1e3,
    microseconds: roundTowardsZero(milliseconds * 1e3) % 1e3,
    nanoseconds: roundTowardsZero(milliseconds * 1e6) % 1e3
  };
};
const parseMilliseconds = parseMs;
const pluralize = (word, count) => count === 1 ? word : `${word}s`;
const SECOND_ROUNDING_EPSILON = 1e-7;
var prettyMs = (milliseconds, options = {}) => {
  if (!Number.isFinite(milliseconds)) {
    throw new TypeError("Expected a finite number");
  }
  if (options.colonNotation) {
    options.compact = false;
    options.formatSubMilliseconds = false;
    options.separateMilliseconds = false;
    options.verbose = false;
  }
  if (options.compact) {
    options.secondsDecimalDigits = 0;
    options.millisecondsDecimalDigits = 0;
  }
  const result = [];
  const floorDecimals = (value, decimalDigits) => {
    const flooredInterimValue = Math.floor(value * 10 ** decimalDigits + SECOND_ROUNDING_EPSILON);
    const flooredValue = Math.round(flooredInterimValue) / 10 ** decimalDigits;
    return flooredValue.toFixed(decimalDigits);
  };
  const add = (value, long, short, valueString) => {
    if ((result.length === 0 || !options.colonNotation) && value === 0 && !(options.colonNotation && short === "m")) {
      return;
    }
    valueString = (valueString || value || "0").toString();
    let prefix;
    let suffix;
    if (options.colonNotation) {
      prefix = result.length > 0 ? ":" : "";
      suffix = "";
      const wholeDigits = valueString.includes(".") ? valueString.split(".")[0].length : valueString.length;
      const minLength = result.length > 0 ? 2 : 1;
      valueString = "0".repeat(Math.max(0, minLength - wholeDigits)) + valueString;
    } else {
      prefix = "";
      suffix = options.verbose ? " " + pluralize(long, value) : short;
    }
    result.push(prefix + valueString + suffix);
  };
  const parsed = parseMilliseconds(milliseconds);
  add(Math.trunc(parsed.days / 365), "year", "y");
  add(parsed.days % 365, "day", "d");
  add(parsed.hours, "hour", "h");
  add(parsed.minutes, "minute", "m");
  if (options.separateMilliseconds || options.formatSubMilliseconds || !options.colonNotation && milliseconds < 1e3) {
    add(parsed.seconds, "second", "s");
    if (options.formatSubMilliseconds) {
      add(parsed.milliseconds, "millisecond", "ms");
      add(parsed.microseconds, "microsecond", "µs");
      add(parsed.nanoseconds, "nanosecond", "ns");
    } else {
      const millisecondsAndBelow = parsed.milliseconds + parsed.microseconds / 1e3 + parsed.nanoseconds / 1e6;
      const millisecondsDecimalDigits = typeof options.millisecondsDecimalDigits === "number" ? options.millisecondsDecimalDigits : 0;
      const roundedMiliseconds = millisecondsAndBelow >= 1 ? Math.round(millisecondsAndBelow) : Math.ceil(millisecondsAndBelow);
      const millisecondsString = millisecondsDecimalDigits ? millisecondsAndBelow.toFixed(millisecondsDecimalDigits) : roundedMiliseconds;
      add(
        Number.parseFloat(millisecondsString, 10),
        "millisecond",
        "ms",
        millisecondsString
      );
    }
  } else {
    const seconds = milliseconds / 1e3 % 60;
    const secondsDecimalDigits = typeof options.secondsDecimalDigits === "number" ? options.secondsDecimalDigits : 1;
    const secondsFixed = floorDecimals(seconds, secondsDecimalDigits);
    const secondsString = options.keepDecimalsOnWholeSeconds ? secondsFixed : secondsFixed.replace(/\.0+$/, "");
    add(Number.parseFloat(secondsString, 10), "second", "s", secondsString);
  }
  if (result.length === 0) {
    return "0" + (options.verbose ? " milliseconds" : "ms");
  }
  if (options.compact) {
    return result[0];
  }
  if (typeof options.unitCount === "number") {
    const separator = options.colonNotation ? "" : " ";
    return result.slice(0, Math.max(options.unitCount, 1)).join(separator);
  }
  return options.colonNotation ? result.join("") : result.join(" ");
};
const pms = /* @__PURE__ */ getDefaultExportFromCjs(prettyMs);
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("lte-box", {
    attrs: {
      "type": `box-${_vm.status.type}`
    }
  }, [_c("div", {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c("div", {}, [_vm._v(" " + _vm._s(_vm.item.description) + " ")]), _c("div", {
    staticClass: "mt-2"
  }, [_vm._v(" #" + _vm._s(_vm.item.installed_rank) + " "), _c("bs-label", {
    attrs: {
      "type": `label-${_vm.status.type}`
    }
  }, [_vm._v(" " + _vm._s(_vm.status.text) + " ")]), _vm._v(" • " + _vm._s(_vm.executionTime) + " • "), _c("span", {
    staticClass: "small"
  }, [_vm._v(" " + _vm._s(_vm.item.script) + " ")])], 1)]), _c("div", {
    staticClass: "d-flex flex-column align-items-end",
    attrs: {
      "slot": "tools"
    },
    slot: "tools"
  }, [_c("div", [_c("bs-label", {
    attrs: {
      "type": `label-${_vm.version.type}`
    }
  }, [_vm._v(" " + _vm._s(_vm.version.text) + " ")])], 1), _c("div", {
    staticClass: "mt-2"
  }, [_c("datetime-from-now", {
    attrs: {
      "date-time": _vm.item.installed_on
    }
  })], 1)])]);
};
var staticRenderFns$2 = [];
const __vue2_script$2 = {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    status() {
      if (this.item.success) {
        return {
          type: "success",
          text: "Sucesso"
        };
      }
      return {
        type: "danger",
        text: "Falha"
      };
    },
    executionTime() {
      return pms(this.item.execution_time);
    },
    version() {
      if (this.item.version) {
        return {
          type: "primary",
          text: this.item.version
        };
      }
      return {
        type: "default",
        text: "R"
      };
    }
  }
};
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$2,
  render$2,
  staticRenderFns$2,
  false,
  __vue2_injectStyles$2,
  null,
  null,
  null
);
function __vue2_injectStyles$2(context) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
const ListaItem = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("bs-row", [_c("bs-col", {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_vm._l(_vm.lista, function(item) {
    return _c("bs-row", {
      key: item.id
    }, [_c("bs-col", {
      attrs: {
        "md": "12",
        "sm": "12"
      }
    }, [_c("lista-item", {
      attrs: {
        "item": item
      }
    })], 1)], 1);
  }), _vm.lista.length === 0 ? _c("bs-alert", {
    attrs: {
      "type": "alert-info",
      "hide-close": ""
    }
  }, [_c("div", [_vm._v("Nenhum migration encontrado.")])]) : _vm._e(), _vm._t("paginacao")], 2)], 1);
};
var staticRenderFns$1 = [];
const __vue2_script$1 = {
  props: {
    lista: {
      type: Array,
      required: true
    }
  },
  components: {
    ListaItem
  }
};
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1,
  render$1,
  staticRenderFns$1,
  false,
  __vue2_injectStyles$1,
  null,
  null,
  null
);
function __vue2_injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
const ContainerLista = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "container my-5"
  }, [_c("div", {
    staticClass: "d-flex"
  }, [_c("div", {
    staticClass: "d-flex align-items-center"
  }, [_c("a", {
    attrs: {
      "href": _vm.$app.url("/")
    }
  }, [_vm._v("Voltar")])]), _vm._m(0)]), _c("hr", {
    staticStyle: {
      "border-top": "1px solid var(--grey-5)"
    }
  }), _c("container-lista", {
    staticClass: "mt-2",
    attrs: {
      "lista": _vm.lista
    }
  }, [_c("bs-paginacao-simples", {
    attrs: {
      "slot": "paginacao",
      "pagina": _vm.pagina,
      "max-paginas": _vm.maxPaginas,
      "lista": _vm.lista,
      "itens-por-pagina": _vm.itensPorPagina
    },
    on: {
      "click-anterior": _vm.clickAnterior,
      "click-proximo": _vm.clickProximo
    },
    slot: "paginacao"
  })], 1)], 1);
};
var staticRenderFns = [function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ml-2"
  }, [_c("h3", [_vm._v("Migrations")])]);
}];
const __vue2_script = {
  components: {
    ContainerLista
  },
  data() {
    return {
      lista: [],
      isLoading: false,
      pagina: 1,
      maxPaginas: 100,
      itensPorPagina: 50
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    listar(onComplete) {
      this.isLoading = true;
      const promise = $.get(`${_app}/api/migrations/`, {
        pagina: this.pagina
      });
      promise.done((json) => {
        this.lista = json.lista || [];
      });
      promise.fail(window.ajaxHelper.fail);
      promise.always(() => {
        this.isLoading = false;
        if (onComplete) {
          onComplete();
        }
      });
    },
    clickAnterior() {
      this.pagina--;
      this.listar(this.irParaTopo);
    },
    clickProximo() {
      this.pagina++;
      this.listar(this.irParaTopo);
    },
    irParaTopo() {
      $("html,body").animate({
        scrollTop: $(this.$el).offset().top
      }, 500);
    }
  }
};
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(
  __vue2_script,
  render,
  staticRenderFns,
  false,
  __vue2_injectStyles,
  null,
  null,
  null
);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
const IndexContainer = /* @__PURE__ */ function() {
  return __component__.exports;
}();
const $$1 = window.jQuery;
Vue.use(BootstrapPlugin);
Vue.use(CommonPlugin);
Vue.use(AdminLtePlugin);
$$1(() => {
  new Vue({
    components: {
      IndexContainer
    },
    render(h) {
      return h("index-container");
    }
  }).$mount("#app-container");
});
